"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thankYouMessages = void 0;
exports.thankYouMessages = {
    en: {
        ebook: {
            header: 'Thank You!',
            text: 'Your requested resource will be sent to your inbox shortly.',
            textBold: 'Need help with your next campaign?',
            button: {
                text: 'Download',
                class: 'btn btn-main btn--arrow btn--arrow-navy btn--left'
            }
        },
        webinar: {
            header: 'Thank you for registration',
            text: 'A link to join the webinar will be sent to your inbox.',
        },
        webinar_it: {
            header: 'Grazie per la registrazione!',
            text: 'Un link per partecipare al webinar verrà inviato alla tua casella di posta.',
        },
        webinar_es: {
            header: '¡Gracias por registrarte!',
            text: 'Enviaremos el link para unirte al webinar a tu bandeja de entrada.',
        },
        register: {
            header: 'Thank you for registering.',
            text: 'We will send you an email shortly with a link to the webinar.',
            button: {
                text: 'Back to Site',
                class: 'btn btn-main btn--arrow btn--arrow-navy btn--left mb-3 formController'
            },
            buttonSec: {
                text: 'Add to Calendar',
                class: 'btn btn-bordered btn--arrow btn--left'
            }
        },
        heroForm: {
            header: 'Thank you!',
            text: 'We will get in touch with you shortly.'
        },
        default: {
            header: 'Thank you',
            text: 'We will get in touch with you shortly.',
            button: {
                text: 'Back to Site',
                class: 'btn btn-main btn--arrow btn--arrow-navy btn--left formController'
            }
        }
    },
    pl: {
        ebook: {
            header: 'Dziękujemy!',
            text: 'Twój eBook został wysłany na podany adres email.',
            textBold: 'Potrzebujesz pomocy z następną kampanią?',
            button: {
                text: 'Pobierz',
                class: 'btn btn-main btn--arrow btn--arrow-navy btn--left'
            }
        },
        webinar: {
            header: 'Dziękujemy za rejestrację',
            text: 'Link umożliwiający dołączenie do webinarium zostanie wysłany na Twoją skrzynkę odbiorczą',
        },
        register: {
            header: 'Dziękujemy za rejestrację.',
            text: 'Link do spotkania zostanie wysłany na podany adres email.',
            button: {
                text: 'Wróć do strony',
                class: 'btn btn-main btn--arrow btn--arrow-navy btn--left mb-3 formController'
            },
            buttonSec: {
                text: 'Dodaj do kalendarza',
                class: 'btn btn-bordered btn--arrow btn--left'
            }
        },
        default: {
            header: 'Dziękujemy',
            text: 'Skontaktujemy się z tobą wkrótce.',
            button: {
                text: 'Wróć do strony',
                class: 'btn btn-main btn--arrow btn--arrow-navy btn--left formController'
            }
        }
    }
};
